import { render } from "./HealthPlatform.vue?vue&type=template&id=35136e4e&scoped=true"
import script from "./HealthPlatform.vue?vue&type=script&lang=js"
export * from "./HealthPlatform.vue?vue&type=script&lang=js"

import "./HealthPlatform.vue?vue&type=style&index=0&id=35136e4e&scoped=true&lang=css"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35136e4e"]])

export default __exports__